import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  constructor(public apiService: ApiService) { }

  getTasks(body : any): Observable<any> {
    // return this.apiService.post('tasks/getTasks', body)
    return this.apiService.post('RoleTask/getAllTaskByRole', body)
  }

  addTasksForMasterUserAndSubUser(body : any): Observable<any> {
   return this.apiService.post('CompanyUserRole/createRoleToMasterAndSubUser', body)
    // return this.apiService.post('tasks/createTasks', body)
  }
  addTasksForSubUser(body : any): Observable<any> {
    return this.apiService.post('', body)
     // return this.apiService.post('tasks/createTasks', body)
   }
}
